module.exports = __webpack_public_path__ + "35367437b3224d692ae05f0c66053b93.woff2";